var actions = {
	next: "Далее",
	confirm: "Подтвердить",
	"continue": "Продолжить"
};
var errors = {
	unknown: "Произошла неизвестная ошибка",
	contactSupport: "Произошла ошибка. Обратитесь в службу поддержки.",
	tryAgain: "Произошла ошибка. Попробуйте еще раз.",
	submit: "Произошла ошибка при отправке."
};
var brands = {
	apple: "Apple",
	facebook: "Facebook",
	google: "Google",
	paypal: "PayPal",
	picarto: "Picarto",
	tiktok: "TikTok",
	trovo: "Trovo",
	twitch: "Twitch",
	youtube: "YouTube",
	twitter: "X (Twitter)",
	linkedin: "LinkedIn",
	streamlabs: "Streamlabs",
	mevo: "Mevo",
	typestudio: "TypeStudio"
};
var loginButton = {
	loginWith: "Вход с помощью {name}",
	signupWith: "Регистрация с помощью {name}"
};
var alreadyHaveAccount = {
	company: "Уже есть учетная запись {company}?",
	text: "Уже есть идентификатор Streamlabs ID?",
	link: "Вход"
};
var noAccount = {
	text: "Еще нет учетной записи?",
	link: "Регистрация"
};
var validation = {
	email: {
		invalid: "Укажите действительный адрес электронной почты"
	},
	password: {
		required: "Необходимо ввести пароль",
		min: "Пароль должен содержать более 8 символов",
		number: "Пароль должен содержать число",
		upper: "Пароль должен содержать символ верхнего регистра",
		special: "Пароль должен содержать специальный символ"
	},
	username: {
		invalid: "Имя должно состоять не менее чем из 5 символов"
	},
	code: {
		minmax: "Код должен содержать от 6 до 10 символов"
	}
};
var poweredBy = "При поддержке <company>Streamlabs</company>";
var card = {
	"404": {
		title: "Компания не найдена.",
		desc: "Повторите попытку позже или обратитесь в службу поддержки."
	},
	company: {
		logoAlt: "Логотип {company}"
	}
};
var checkTfaForm = {
	tfaCodePlaceholder: "6-значный код аутентификации / 8-значный резервный код",
	successText: "Готово! Перенаправление...",
	remember: "Запомнить это устройство на 30 дней"
};
var createTfa = {
	scan: {
		title: "Включите двухфакторную аутентификацию",
		lead: "Нажмите и скопируйте указанный ниже код или отсканируйте его с помощью предпочитаемой программы для аутентификации. Мы рекомендуем использовать следующие программы для безопасного хранения кодов: <app0 />, <app1 /> или <app2 />.",
		copied: "Скопировано.",
		instructions: "Или введите этот код вручную в программе для аутентификации.",
		copy: "Скопировать код",
		proceed: "Подтверждение"
	},
	confirm: {
		title: "Подтвердите двухфакторную аутентификацию",
		lead: "Отправьте сгенерированный код, указанный ниже, чтобы подтвердить включение двухфакторной аутентификации.",
		label: "Код двухфакторной аутентификации (6 цифр)",
		verify: "Подтвердить код",
		next: "Готово! Следующий шаг"
	},
	save: {
		title: "Сохраните резервные коды",
		lead: "Сохраните резервные коды, указанные ниже, на случай потери доступа к программе для двухфакторной аутентификации. После закрытия этого модального окна данные коды больше не будут доступны.",
		label: "Резервные коды",
		download: "Загрузить резервные коды",
		copied: "Коды скопированы.",
		finished: "Готово"
	}
};
var emailLoginForm = {
	buttonText: "Вход",
	emailPlaceholder: "Адрес эл. почты",
	passwordPlaceholder: "Пароль"
};
var emailSignupForm = {
	buttonText: "Регистрация",
	emailPlaceholder: "Укажите адрес эл. почты",
	passwordPlaceholder: "Задайте пароль",
	usernamePlaceholder: "Ваше имя",
	ageLabel: "Дата рождения",
	agePlaceholder: "ММ/ДД/ГГГГ",
	agreeText: "Я соглашаюсь с <terms>Условиями предоставления услуг</terms> и <privacy>Политикой конфиденциальности</privacy> Streamlabs.",
	agreeError: "Согласитесь с условиями и положениями Streamlabs."
};
var ageInput = {
	invalidDate: "Введите правильную дату рождения",
	futureDate: "Дата рождения должна быть прошедшей",
	minDate: "Запрещено вводить даты, которые наступили до {year} года",
	minAge_one: "Минимальный возраст для использования Streamlabs: {years}",
	minAge_two: "Минимальный возраст для использования Streamlabs: {years}",
	minAge_other: "Минимальный возраст для использования Streamlabs: {years}"
};
var forgotPasswordForm = {
	emailPlaceholder: "Адрес эл. почты",
	back: "Вернуться к странице «Вход в систему»",
	successText: "Готово! Вам отправлен код для сброса пароля",
	buttonText: "Запросить сброс адреса эл. почты",
	create: {
		successText: "Готово! Мы отправили вам код подтверждения, с помощью которого можно приступить к работе!",
		buttonText: "Запросить код подтверждения"
	},
	errors: {
		notFound: "Не найдена учетная запись, связанная с данным адресом электронной почты"
	}
};
var forgotPasswordCard = {
	forgot: {
	},
	title: "Забыли пароль?",
	lead: "При необходимости сбросить пароль введите свой адрес электронной почты, и мы отправим на него соответствующее письмо.",
	resetTitle: "Сбросьте пароль",
	resetLead: "Вы должны были получить код по электронной почте. Заполните форму, чтобы сбросить пароль.",
	create: {
		title: "Создайте собственный пароль",
		lead: "Поздравляем с созданием Streamlabs ID! Еще один шаг, и вы сможете входить в Streamlabs с любых устройств!",
		resetTitle: "Выберите пароль",
		resetLead: "Вы должны были получить код по электронной почте. Воспользуйтесь им и заполните форму, чтобы сбросить пароль."
	},
	successText: "Готово! Перенаправление...",
	signInTitle: "Уже есть учетная запись?",
	signInBtn: "Вход"
};
var checkTfaCard = {
	title: "Проверка с помощью двухфакторной аутентификации",
	lead: "Чтобы продолжить, введите код двухфакторной аутентификации.",
	successText: "Двухфакторная аутентификация пройдена успешно.",
	back: "Вернуться назад"
};
var verifyEmailCard = {
	title: "Подтвердите адрес электронной почты",
	lead: "Вам отправлено электронное письмо от Streamlabs с 8-значным кодом. Введите этот код в поле ниже.",
	back: "Вернуться назад",
	successText: "Адрес электронный почты подтвержден."
};
var upgradeCard = {
	confirm: {
		title: "Подтвердить подключение {company}",
		userLine: "<b>Streamlabs ID</b> {email}",
		items: [
			"Далее вы сможете войти в систему {company}, используя указанные адрес электронной почты и пароль.",
			"Вы можете получить доступ ко всем продуктам из Streamlabs с помощью ID и подключить другие существующие учетные записи при их наличии.",
			"Данное изменение не повлияет на вашу учетную запись {company}."
		],
		button: "Подтвердить",
		cancel: "Отменить",
		switchAccount: "Сменить учетную запись",
		success: "Подключение..."
	},
	confirmed: {
		title: "Готово!",
		subtitle: "Ваш Streamlabs ID был создан, а учетная запись {company} подключена.",
		text: "Streamlabs ID можно использовать для всех продуктов Streamlabs. Если у вас есть другие учетные записи, вы можете подключить их к этому ID из каждого приложения.",
		button: "Закрыть"
	},
	error: {
		user: "Не удалось идентифицировать пользователя. Повторите попытку входа или обратитесь в службу поддержки."
	}
};
var confirmCard = {
	confirm: {
		title: "Подтвердить подключение {company}",
		subtitle: "Мы обнаружили учетную запись с подходящим адресом электронной почты. Желаете объединить эту учетную запись со Streamlabs ID?",
		userLine: "<b>Streamlabs ID</b> {email}",
		items: [
			"Вы сможете войти в систему {company}, используя адрес электронной почты и пароль, которые вы указали в Streamlabs ID.",
			"Вы можете получить доступ ко всем продуктам из Streamlabs с помощью ID и подключить другие существующие учетные записи при их наличии.",
			"Данное изменение не повлияет на вашу корпоративную учетную запись."
		],
		button: "Подтвердить",
		cancel: "Отменить",
		switchAccount: "Сменить учетную запись",
		success: "Подключение..."
	},
	confirmed: {
		title: "Готово!",
		subtitle: "Ваш Streamlabs ID был создан, а учетная запись {company} подключена.",
		text: "Streamlabs ID можно использовать для всех продуктов Streamlabs. Если у вас есть другие учетные записи, вы можете подключить их к этому ID из каждого приложения.",
		button: "Закрыть"
	},
	error: {
		user: "Не удалось идентифицировать пользователя. Повторите попытку входа или обратитесь в службу поддержки."
	}
};
var upgradeConfirmCard = {
	confirm: {
		title: " К вашему ID уже подключена учетная запись {company}",
		subtitle: "Желаете отключить подключенную учетную запись и привязать текущую учетную запись Streamlabs?",
		userLine: "<b>Streamlabs ID</b> {email}",
		items: [
			"Вы сможете войти в систему Streamlabs, используя адрес электронной почты и пароль, которые вы указали для Streamlabs ID.",
			"Вы можете получить доступ ко всем продуктам из Streamlabs с помощью ID и подключить другие существующие учетные записи при их наличии.",
			"Данное изменение не повлияет на вашу учетную запись Streamlabs."
		],
		button: "Подтвердить",
		cancel: "Отменить",
		switchAccount: "Сменить учетную запись",
		success: "Подключение...",
		agreeLabel: "Я понимаю, что, создавая эту связь, я утрачу доступ к существующей учетной записи {company}, которую я ранее привязал(-а) к Streamlabs ID."
	},
	confirmed: {
		title: "Готово!",
		subtitle: "Ваш Streamlabs ID был создан, а учетная запись {company} подключена.",
		text: "Streamlabs ID можно использовать для всех продуктов Streamlabs. Если у вас есть другие учетные записи, вы можете подключить их к этому ID из каждого приложения.",
		button: "Закрыть"
	},
	error: {
		user: "Не удалось идентифицировать пользователя. Повторите попытку входа или обратитесь в службу поддержки."
	}
};
var loginCard = {
	title: "Вход",
	lead: "Вход в <company>{company}</company> с помощью <id>идентификатора Streamlabs ID</id>",
	accountExists: "Похоже, что у вас есть <b>идентификатор Streamlabs ID</b>. Попробуйте войти в систему с помощью электронной почты.",
	forgotPassword: "Забыли пароль?",
	successText: "Готово! Перенаправление...",
	signInTitle: "Вход через платформу"
};
var loginSourcesCard = {
	title: "Вход",
	lead: "Вход с помощью адреса электронной почты и пароля",
	withSlId: "Вход с помощью идентификатора Streamlabs ID",
	noAccountMessage: "Не найдена учетная запись, связанная с этим методом входа. Попробуйте другой метод входа или <signup>Зарегистрируйтесь</signup>, если вы еще этого не сделали.",
	accountExistsMessage: "Ваш адрес электронной почты Twitch уже связан со Streamlabs. Попробуйте войти в систему с помощью электронной почты и пароля от Streamlabs."
};
var resetPasswordForm = {
	emailPlaceholder: "Адрес эл. почты",
	codePlaceholder: "Код из электронного письма (6‒8 цифр)",
	tfaCodePlaceholder: "Код двухфакторной аутентификации",
	newPasswordPlaceholder: "Новый пароль",
	tfaError: "Код сброса должен содержать от 6 до 10 символов",
	next: "Получили код?",
	back: "Вернуться к странице «Забыли пароль?»",
	buttonText: "Изменить пароль",
	successText: "Пароль сброшен",
	create: {
		back: "К началу",
		buttonText: "Задать пароль",
		successText: "Пароль успешно задан"
	}
};
var changePasswordForm = {
	currentPasswordPlaceholder: "Текущий пароль",
	newPasswordPlaceholder: "Новый пароль",
	newPasswordConfirmationPlaceholder: "Подтвердить новый пароль",
	buttonText: "Изменить пароль",
	successText: "Пароль успешно обновлен",
	newPasswordConfirmationError: "Новые пароли не совпадают",
	back: "Вернуться к панели управления"
};
var changePasswordCard = {
	title: "Измените пароль",
	lead: "Введите ваш текущий пароль и новый пароль в поля ниже.",
	successText: "Пароль успешно обновлен"
};
var removeTfaForm = {
	tfaCodePlaceholder: "6-значный код аутентификации / 8-значный резервный код",
	successText: "Двухфакторная аутентификация отключена",
	removeBtn: "Подтвердить и отключить"
};
var removeTfaCard = {
	title: "Убрать двухфакторную аутентификацию",
	lead: "Введите код подтверждения в поле ниже, чтобы отключить двухфакторную аутентификацию для вашей учетной записи.",
	successText: "Двухфакторная аутентификация отключена",
	back: "Вернуться к панели управления"
};
var verifyEmailForm = {
	codePlaceholder: "8-значный код из электронного письма",
	tfaCodePlaceholder: "Код двухфакторной аутентификации",
	emailPlaceholder: "Адрес электронной почты",
	buttonText: "Подтвердить адрес электронной почты",
	successText: "Адрес электронный почты успешно подтвержден",
	requestBtn: "Запросить новый код",
	requestingBtn: "Идет запрос...",
	requestSuccess: "Код был отправлен на вашу электронную почту",
	requestAgain: "Запросить еще раз через {seconds} с",
	tfaError: "Код сброса должен содержать от 6 до 10 символов",
	back: "Вернуться назад"
};
var signupCard = {
	title: "Регистрация",
	lead: "Создайте учетную запись <id>Streamlabs ID</id>, чтобы использовать <company>{company}</company>",
	successText: "Готово! Перенаправление..."
};
var signupSourcesCard = {
	title: "Регистрация",
	lead: "Создайте учетную запись <id>Streamlabs ID</id>, чтобы использовать <company>{company}</company>",
	withSlId: "Создать Streamlabs ID"
};
var connectCard = {
	connect: {
		title: "Выберите учетную запись,",
		lead: "чтобы продолжить <b>{company}</b>",
		authorize: "Пройдите авторизацию",
		authorizeSuccess: "Готово!",
		cancel: "Отменить",
		disclaimer: {
			streamlabs: "Если вы продолжите, данные вашего Streamlabs ID (имя, адрес электронной почты, языковые предпочтения и фотография профиля) будут предоставлены <b>{company}</b>. Предоставляя учетной записи разрешение на <b>{company}</b>, вы тем самым выражаете согласие с <privacy>политикой конфиденциальности</privacy> и <terms>условиями предоставления услуг</terms> <b>{company}</b>.",
			"default": "Если вы продолжите работу, Streamlabs предоставит данные с вашим именем, адресом электронной почты, языковыми предпочтениями и фотографией профиля <b>{company}</b>. Предоставляя учетной записи разрешение на <b>{company}</b>, вы тем самым выражаете согласие с <privacy>политикой конфиденциальности</privacy> и <terms>условиями предоставления услуг</terms> <b>{company}</b>."
		},
		emailRequired: "Для продолжения работы необходимо подтвердить адрес электронной почты",
		tfaRequired: "Для продолжения работы необходимо пройти двухфакторную аутентификацию"
	},
	login: {
		title: "Вход в {company}",
		lead: "Для подключения учетных записей необходимо войти в систему",
		loginBtn: "Перейти к входу в систему"
	},
	error: {
		title: "Вход в {company}",
		lead: "Ваш запрос не может быть выполнен в данный момент.",
		verifyEmail: "Подтвердить адрес электронной почты",
		verify2fa: "Подтвердить с помощью двухфакторной аутентификации"
	},
	"switch": {
		btn: "Использовать другую учетную запись"
	}
};
var appsDropdown = {
	label: "Продукты и приложения Streamlabs",
	viewMore: "Развернуть",
	viewLess: "Свернуть"
};
var platformButtons = {
	loginWithPlatform: "Вход через платформу",
	signUpWithPlatform: "Регистрация через платформу",
	signUpLead: "Мы поддерживаем трансляцию для многих платформ; это только варианты регистрации."
};
var ultraCheckoutCard = {
	title: "Повысьте качество ваших прямых трансляций, брендинга, монтажа, и не только с подпиской <b>Streamlabs Ultra</b>",
	badge: "Включает:<b>{planName}</b>",
	totalValue: "Цена {price, currency}",
	price: {
		month: "{price, currency}/мес.",
		year: "{price, currency}/год"
	},
	description: {
		month: "Получите доступ к полному набору премиальных функций, включая <b>Streamlabs Desktop</b>, <b>Console</b>, <b>Talk Studio</b>, <b>Podcast Editor</b>, <b>Cross Clip</b> и многое другое, по одной доступной цене.",
		year: "Получите доступ к полному набору премиальных функций, включая <b>Streamlabs Desktop</b>, <b>Console</b>, <b>Talk Studio</b>, <b>Podcast Editor</b>, <b>Cross Clip</b> и многое другое, по одной доступной цене."
	},
	seeIncluded: "Подробнее",
	buyNow: "Обновить"
};
var ultraCheckoutBanner = {
	title: "Повысьте качество ваших прямых трансляций, брендинга, монтажа, и не только с подпиской <b>Streamlabs Ultra</b>",
	badge: "Включает:<b>{planName}</b>",
	totalValue: "Цена {price, currency}",
	price: {
		month: "{price, currency}/мес.",
		year: "{price, currency}/год"
	},
	description: {
		month: "Получите доступ к полному набору премиальных функций, включая <b>Streamlabs Desktop</b>, <b>Console</b>, <b>Talk Studio</b>, <b>Podcast Editor</b>, <b>Cross Clip</b> и многое другое, по одной доступной цене. <link />",
		year: "Получите доступ к полному набору премиальных функций, включая <b>Streamlabs Desktop</b>, <b>Console</b>, <b>Talk Studio</b>, <b>Podcast Editor</b>, <b>Cross Clip</b> и многое другое, по одной доступной цене. <link />"
	},
	seeIncluded: "Подробнее",
	buyNow: "Обновить"
};
var connect = {
	waitMessage: "Объединение данных. Не закрывайте окно."
};
var verifyPasswordCard = {
	success: "Пароль успешно подтвержден",
	title: "Для подтверждения выполните повторную авторизацию",
	lead: "Войдите в систему с помощью существующего адреса электронной почты и пароля, чтобы продолжить обновление Streamlabs ID.",
	buttonText: "Далее"
};
var emailChangeForm = {
	agreeError: "Подтвердите, что понимаете данное данное действие",
	buttonText: "Далее",
	emailPlaceholder: "Новый адрес электронной почты",
	agreeText: "Я понимаю, что после подтверждения мой Streamlabs ID изменится во всех продуктах Streamlabs, к которым он подключен."
};
var verifyNewEmailCard = {
	title: "Смените Streamlabs ID",
	lead: "Введите новый адрес электронной почты для использования в качестве Streamlabs ID. На этот адрес мы вышлем вам код проверки, состоящий из 6–8 цифр.",
	successText: "Доступен новый адрес электронной почты"
};
var verifyNewEmailOwnershipCard = {
	title: "Подтвердите обновленный Streamlabs ID",
	lead: "Вам отправлено электронное письмо от Streamlabs с 8-значным кодом. Введите этот код в поле ниже.",
	buttonText: "Подтвердить",
	back: "Назад",
	codePlaceholder: "8-значный код из электронного письма",
	successText: "Владение адресом электронной почты успешно подтверждено"
};
var verifyTfaCard = {
	title: "Код подтверждения для двухфакторной аутентификации",
	lead: "Введите 6-значный код подтверждения из приложения аутентификации.",
	codePlaceholder: "6-значный код",
	buttonText: "Подтвердить",
	successText: "Двухфакторная аутентификация пройдена",
	back: "Назад"
};
var ageGateForm = {
	ageLabel: "Дата рождения",
	agePlaceholder: "ММ/ДД/ГГГГ"
};
var ageGateCard = {
	title: "Завершите настройку учетной записи",
	lead: {
		years: "Минимальный возраст для создания учетной записи: {years}. <br />Чтобы завершить настройку, введите свою дату рождения.",
		noYears: "Чтобы создать учетную запись, необходимо указать свою дату рождения. <br />Введите, чтобы завершить настройку."
	},
	successText: "Поздравляем! Настройка учетной записи завершена."
};
var ruRU = {
	actions: actions,
	errors: errors,
	brands: brands,
	loginButton: loginButton,
	alreadyHaveAccount: alreadyHaveAccount,
	noAccount: noAccount,
	validation: validation,
	poweredBy: poweredBy,
	card: card,
	checkTfaForm: checkTfaForm,
	createTfa: createTfa,
	emailLoginForm: emailLoginForm,
	emailSignupForm: emailSignupForm,
	ageInput: ageInput,
	forgotPasswordForm: forgotPasswordForm,
	forgotPasswordCard: forgotPasswordCard,
	checkTfaCard: checkTfaCard,
	verifyEmailCard: verifyEmailCard,
	upgradeCard: upgradeCard,
	confirmCard: confirmCard,
	upgradeConfirmCard: upgradeConfirmCard,
	loginCard: loginCard,
	loginSourcesCard: loginSourcesCard,
	resetPasswordForm: resetPasswordForm,
	changePasswordForm: changePasswordForm,
	changePasswordCard: changePasswordCard,
	removeTfaForm: removeTfaForm,
	removeTfaCard: removeTfaCard,
	verifyEmailForm: verifyEmailForm,
	signupCard: signupCard,
	signupSourcesCard: signupSourcesCard,
	connectCard: connectCard,
	appsDropdown: appsDropdown,
	platformButtons: platformButtons,
	ultraCheckoutCard: ultraCheckoutCard,
	ultraCheckoutBanner: ultraCheckoutBanner,
	connect: connect,
	verifyPasswordCard: verifyPasswordCard,
	emailChangeForm: emailChangeForm,
	verifyNewEmailCard: verifyNewEmailCard,
	verifyNewEmailOwnershipCard: verifyNewEmailOwnershipCard,
	verifyTfaCard: verifyTfaCard,
	ageGateForm: ageGateForm,
	ageGateCard: ageGateCard
};

export { ruRU as r };
//# sourceMappingURL=ru-RU.es.js.map
